import store from '@Store';
import { updateDialog } from '@Containers/Dialogs/DialogsActions';
import { typeOfReencryptionNotifyModal } from '@Containers/ReencryptionNotifyModal/ReencryptionNotifyModalConstants';

// eslint-disable-next-line import/prefer-default-export
export function openReEncryptionStatusModalWindow() {
  store.dispatch(
    updateDialog({
      id: typeOfReencryptionNotifyModal,
      dialogType: typeOfReencryptionNotifyModal,
      movable: false,
      backdrop: false,
      closeButton: false,
      className: 'reencryption-notify-modal-dialog-wrap',
    })
  );
}
